module.exports = __webpack_public_path__ + "images/blue-link.gif";